<div class="side-panel-products-container">

    
    <mat-spinner *ngIf="isTotalProductsLoading" diameter="24"></mat-spinner>
    

    
    <div *ngIf="!isTotalProductsLoading">
        @if (nProducts != null) {
            <p class="products-found-txt">Hai individuato</p>
            <p class="side-panel-n-products">
        
                {{nProducts | number}}<span class="total-with-nProducts"> su </span>
        
                <span class="total-with-nProducts">{{(totalProducts | number) ?? '-'}}</span>
        
                <span class="total-with-nProducts"> prodotti</span>
        
            </p>
        
            }
            @else {
            <p class="products-found-txt">Sono presenti in totale</p>
            <p class="side-panel-n-products">
                <span>{{(totalProducts | number) ?? '-'}}</span>
            </p>
            <p class="side-panel-insurance-txt">Polizze Vita</p>
        
            }

    </div>


   

    







</div>